type Props = {
  className?: string;
};

export default function Monolith({ className = '' }: Props) {
  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 z-10 ${className}`}
    >
      <img
        src="/logo.png"
        alt=""
        className="absolute left-6 top-6 h-24 w-auto md:left-10 md:top-10 md:h-28"
      />
      <span className="absolute bottom-5 right-6 font-display text-base text-gold md:bottom-9 md:right-10">
        →
      </span>
    </div>
  );
}
